import { Form, type FormItemProps, Input } from 'antd';
import type { FC } from 'react';
import type { EventDuplicateFormFields } from './EventDuplicateModal';

interface Props {
  oldEventName: string;
}

const hint = 'New event name needs to be different from original.';

export const NewEventNameField: FC<Props> = ({ oldEventName }) => {
  const rules: FormItemProps<EventDuplicateFormFields>['rules'] = [
    {
      required: true,
      message: 'Event name is required',
    },
    {
      validator: async (_, value) => {
        if (value === oldEventName) throw new Error(hint);
      },
    },
  ];

  return (
    <Form.Item name="newEventName" label="New Event Name" rules={rules}>
      <Input />
    </Form.Item>
  );
};
